(() => {
  const dialog = document.getElementById('tf-newsletter-popup');
  if (!dialog) return;
  // Make Shopify's result visible after the newsletter form returns.
  if (dialog.querySelector('[data-tf-newsletter-feedback]') && !dialog.open) dialog.showModal();
})();
